import './StepSection.scss'
import {ReactNode} from 'react'
import {Title} from '../../../../../genericComponents/typographie/UIKitV2/Title'

export const StepSection = ({
                                title,
                                children
                            }: {
    title: string,
    children?: ReactNode
}) => {
    return <div className="step-section">
        <Title className="step-section-header" title={title}/>
        <div className="step-section-content">
            {children}
        </div>
    </div>
}